import { type FC } from 'react'
import classNames from 'classnames'
import { Image } from '~/components/Image/Image'
import { type BusinessDetailProps } from './BusinessDetail.interface'
import { Tag } from '../Tag/Tag'
import styles from './BusinessDetail.module.scss'
import { Button } from '~/components/Button/Button'
import { Footer } from '~/components/Footer/Footer'

export const BusinessDetail: FC<BusinessDetailProps> = ({
  title,
  description,
  type,
  categories,
  categoryText,
  images,
  address,
  telephone,
  website,
  businessPage,
  footer
}) => {
  const [primaryImage, ...restImages] = images ?? []

  return (
    <div className={styles.container}>
      <div className={styles['image-grid']}>
        {
        primaryImage && (
        <Image
          className={styles['primary-image']}
          src={primaryImage.src}
          alt={primaryImage.alt}
          width={400}
          height={288}
          loading="eager"
          priority
        />
        )
      }
        {restImages?.splice(0, 2).map((image) => (
          <Image
            className={styles['secondary-image']}
            key={image.id}
            src={image.src}
            alt={image.alt}
            width={197}
            height={141}
            loading="eager"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP08DhZDwAEEwHarcD1UgAAAABJRU5ErkJggg=="
            placeholder="blur"
          />
        ))}
      </div>

      <div className={styles.content}>
        <h1 className={styles.name}>{title}</h1>
        <p className={styles.description}>{description}</p>

        <span className={styles.label}>
          Address
          {' '}
          <address className={styles['copy-text']}>{address}</address>
        </span>

        <div className={classNames(styles['contact-grid'], {
          [styles['contact-grid--no-telephone']]: !telephone
        })}
        >
          {telephone && (
          <span className={styles.label}>
            Telephone
            <address className={styles['copy-text']}>
              <a
                className={styles['link-text']}
                href={`tel:${telephone}`}
              >
                {telephone}
              </a>
            </address>
          </span>
          )}

          {website && (
          <span className={styles.label}>
            Website
            {' '}
            <address className={styles['copy-text']}>
              <a
                className={styles['link-text']}
                href={website.url}
                target={website.target}
              >
                {website.text}
              </a>
            </address>
          </span>
          )}
        </div>

        <div className={styles['tag-list']}>
          {categoryText && type && (
            <Tag value={type.value} small variant="secondary">
              {type.name}
            </Tag>
          )}
          {categories?.map((category, i) => (
            <Tag key={category.value} value={category.value} small variant="secondary">
              {category.name}
            </Tag>
          ))}
        </div>

        {categoryText && type && (
          <div className={styles.button}>
            <Button className={styles['button-lower-case']} size="large" link={`/businesses/${type.value}`}>

              <span className={styles['button-capitalize-case']}>View</span>
              {' '}
              all
              {' '}
              {categoryText ?? type.name}
            </Button>
          </div>
        )}

      </div>

      {businessPage && footer && (
      <Footer
        copyrightText={footer.copyrightText}
        footerLinks={footer.footerLinks}
        siteByLabel={footer.siteByLabel}
        siteByLink={footer.siteByLink}
        noContainer
      />
      )}
    </div>
  )
}
